import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../shared/ErrorHandler';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';

@Component({
  selector: 'app-external-issues-form',
  templateUrl: './external-issues-form.component.html',
  styleUrls: ['./external-issues-form.component.css']
})
export class ExternalIssuesFormComponent implements OnInit {
external:any={};
projectslist;
data:any;
cId:any;
fileToUpload: File = null;
formSubmitted: boolean;
  constructor(private userService: UserService, private router: Router,private route: ActivatedRoute,private errorHandler:ErrorHandler) { 
    this.formSubmitted = false;
  }

  ngOnInit() {
    this.GetProjectsforRoles();
  }

  GetProjectsforRoles() {
    debugger;
    // if (this.user != null) {
    //   this.user.RoleId=undefined;
      document.getElementById('loader-spinner').style.display = "block";
      this.data = this.userService.GetProjectsforRoles();
      this.data.subscribe(
        (response:any) => {
          this.projectslist = response;
           for(let i=0;i<=this.projectslist.length;i++) 
          {
            if(i==0)
            this.cId=this.projectslist[i].C_Id;
          }
          // if(this.mode!=null)
          //   this.user.RoleId=this.roleId;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          this.errorHandler.HandlerError(error);
        });
    // }
  }
  
  onSubmit(form: NgForm) {    
     if (!form.invalid) {
    document.getElementById('loader-spinner').style.display = "block";
    console.log('FileUpload');
    console.log(form.value);
    form.value.IS_Client_ID_FK=this.cId;
    form.value.IS_UploadPath = this.getFeasibilityPDFUrl();
    form.value.IS_UploadPath1 = this.getimageUpload1();
    form.value.IS_UploadPath2 = this.getimageUpload2();
    form.value.IS_DisplaytoCustomer = 0;
    this.data = this.userService.createticket(form.value);
    this.data.subscribe(
      (response) => {
        document.getElementById('loader-spinner').style.display = "none";
        swal('Success!', 'Ticket No.' + response + ' has been submitted successfully.', 'success');
         this.router.navigate(['/home/issue-external']);
        }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.HandlerError(error);
      });
    }
    else
    {
    document.getElementById('loader-spinner').style.display = "none";
    swal('Warning!', 'Please Enter all the mandatory fields.', 'warning');
    this.formSubmitted = true;
    }
}

imageUpload(file: FileList) {
  debugger;
      let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
  
      let s: any = file.item(0).size / 1024;
      let size: any = parseFloat(s).toFixed(2);
      let uploadedFilename = file.item(0).name;
      if (uploadedFilename.match(regex) && (size <= 5048)) {
        this.fileToUpload = file.item(0);
        var reader = new FileReader();
        reader.onload = (event: any) => {
          //  this.IS_UploadPath = event.target.result;
        }
        reader.readAsDataURL(this.fileToUpload);
        const data = new FormData();
        data.append("UploadedImage", file.item(0));
        let x = this.userService.uploadImage(data);
        x.subscribe(
          (response) => {
            // console.log(response);
            // this.app.APP_PA_PhotoErrorMessage="";
  
          }, (error) => {
            let i: any = document.getElementById('IS_UploadPath');
            i.value = "";
            if (error.status == 400) {
              //this.FeasibilityPDFUrl = "assets/images/image-default.png";
              swal('Warning!', error.error.Message, 'warning');
            }
          });
      }
      else {
        let i: any = document.getElementById('IS_UploadPath');
        i.value = "";
        if (!uploadedFilename.match(regex))
          swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
        else if (size > 2048)
          swal('Warning!', "Please upload image file less than 2mb", 'warning');
      }
    }
  
  
  
    getFeasibilityPDFUrl() {
      let imagename = null;
      try {
        imagename = document.getElementById('IS_UploadPath');
        return imagename.files[0].name;
      }
      catch (e) {
        return null;
      }
    }

    imageUploadtwo(file: FileList) {
      debugger;
          let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
      
          let s: any = file.item(0).size / 1024;
          let size: any = parseFloat(s).toFixed(2);
          let uploadedFilename = file.item(0).name;
          if (uploadedFilename.match(regex) && (size <= 5048)) {
            this.fileToUpload = file.item(0);
            var reader = new FileReader();
            reader.onload = (event: any) => {
              //  this.IS_UploadPath = event.target.result;
            }
            reader.readAsDataURL(this.fileToUpload);
            const data = new FormData();
            data.append("UploadedImage", file.item(0));
            let x = this.userService.uploadImage(data);
            x.subscribe(
              (response) => {
                // console.log(response);
                // this.app.APP_PA_PhotoErrorMessage="";
      
              }, (error) => {
                let i: any = document.getElementById('IS_UploadPath1');
                i.value = "";
                if (error.status == 400) {
                  //this.FeasibilityPDFUrl = "assets/images/image-default.png";
                  swal('Warning!', error.error.Message, 'warning');
                }
              });
          }
          else {
            let i: any = document.getElementById('IS_UploadPath1');
            i.value = "";
            if (!uploadedFilename.match(regex))
              swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
            else if (size > 2048)
              swal('Warning!', "Please upload image file less than 2mb", 'warning');
          }
        }
      
      
      
        getimageUpload1() {
          let imagename = null;
          try {
            imagename = document.getElementById('IS_UploadPath1');
            return imagename.files[0].name;
          }
          catch (e) {
            return null;
          }
        }

        imageUploadthree(file: FileList) {
          debugger;
              let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
          
              let s: any = file.item(0).size / 1024;
              let size: any = parseFloat(s).toFixed(2);
              let uploadedFilename = file.item(0).name;
              if (uploadedFilename.match(regex) && (size <= 5048)) {
                this.fileToUpload = file.item(0);
                var reader = new FileReader();
                reader.onload = (event: any) => {
                  //  this.IS_UploadPath = event.target.result;
                }
                reader.readAsDataURL(this.fileToUpload);
                const data = new FormData();
                data.append("UploadedImage", file.item(0));
                let x = this.userService.uploadImage(data);
                x.subscribe(
                  (response) => {
                    // console.log(response);
                    // this.app.APP_PA_PhotoErrorMessage="";
          
                  }, (error) => {
                    let i: any = document.getElementById('IS_UploadPath2');
                    i.value = "";
                    if (error.status == 400) {
                      //this.FeasibilityPDFUrl = "assets/images/image-default.png";
                      swal('Warning!', error.error.Message, 'warning');
                    }
                  });
              }
              else {
                let i: any = document.getElementById('IS_UploadPath2');
                i.value = "";
                if (!uploadedFilename.match(regex))
                  swal('Warning!', "Please upload PDF file with extension pdef or pdf", 'warning');
                else if (size > 2048)
                  swal('Warning!', "Please upload image file less than 2mb", 'warning');
              }
            }
          
          
          
            getimageUpload2() {
              let imagename = null;
              try {
                imagename = document.getElementById('IS_UploadPath2');
                return imagename.files[0].name;
              }
              catch (e) {
                return null;
              }
            }
}



// WEBPACK FOOTER //
// ./src/app/issues/external-issues-form/external-issues-form.component.ts